<div class="wrapper">
  <div class="indicator" [ngStyle]="{ width: getWidth() }"></div>
</div>
